import React, { useState, useEffect, useRef } from "react";
import { toast } from "react-toastify";

export default function DistanceFilter({ setShipmentFilters, shipmentFilters }) {
    // Normalize initial values (hide 0, NaN, null, undefined)
    const normalizeValue = (value) => {
        if (value === null || value === undefined || value === 0 || isNaN(Number(value))) {
            return "";
        }
        return Number(value);
    };

    const [localStart, setLocalStart] = useState(normalizeValue(shipmentFilters.startingDistance));
    const [localEnd, setLocalEnd] = useState(normalizeValue(shipmentFilters.endingDistance));

    const hasMounted = useRef(false); // Track first render

    // Debounced + validated filter update
    useEffect(() => {
        if (!hasMounted.current) {
            hasMounted.current = true;
            return; // Skip on mount
        }

        const timeout = setTimeout(() => {
            // Convert empty or 0 → null
            const start =
                localStart === "" || Number(localStart) === 0 ? null : Number(localStart);
            const end = localEnd === "" || Number(localEnd) === 0 ? null : Number(localEnd);

            // Validation
            if (start !== null && end !== null && end <= start) {
                toast.error("Ending distance must be greater than starting distance");
                return;
            }

            // Update filters
            setShipmentFilters((old) => ({
                ...old,
                startingDistance: start,
                endingDistance: end,
            }));
        }, 1000);

        return () => clearTimeout(timeout);
    }, [localStart, localEnd]);

    // Integer-only input
    const handleIntegerInput = (e, setter) => {
        const value = e.target.value;
        if (/^\d*$/.test(value)) setter(value);
    };

    return (
        <div className="bg-white p-3 border-gray-300 -mt-5 rounded-md">
            <span className="pl-[5px] text-gray-500">Filter by order distance (km)</span>
            <div className="flex w-full space-x-3 mt-3">
                {/* Starting Distance */}
                <div className="relative">
                    <input
                        type="text"
                        inputMode="numeric"
                        value={localStart === "" ? "" : localStart}
                        onChange={(e) => handleIntegerInput(e, setLocalStart)}
                        className="w-full bg-white border border-gray-300 rounded-md px-3 py-2 text-sm text-gray-700 focus:outline-none focus:ring-1 focus:ring-blue-400 focus:border-blue-400"
                    />
                    <div className="absolute w-auto h-4 bg-white -top-[11px] px-1 left-3 text-sm text-gray-500 cursor-default select-none rounded-lg">
                        Minimum Distance
                    </div>
                </div>

                {/* Ending Distance */}
                <div className="relative">
                    <input
                        type="text"
                        inputMode="numeric"
                        value={localEnd === "" ? "" : localEnd}
                        onChange={(e) => handleIntegerInput(e, setLocalEnd)}
                        className="w-full bg-white border border-gray-300 rounded-md px-3 py-2 text-sm text-gray-700 focus:outline-none focus:ring-1 focus:ring-blue-400 focus:border-blue-400"
                    />
                    <div className="absolute w-auto h-4 bg-white -top-[11px] px-1 left-3 text-sm text-gray-500 cursor-default select-none">
                        Maximum Distance
                    </div>
                </div>
            </div>
        </div>
    );
}
